export default {
  "Video Compressor": "视频压缩",
  "HitPaw Online Video Compressor": "HitPaw 在线视频压缩",
  "Best video compressor tool to reduce video file size online without losing quality.": "最好的视频压缩器工具，无损在线压缩视频文件大小。",
  Quality: "质量",
  "Small Size": "小尺寸（{{num}}%）",
  "High Quality": "高质量（{{num}}%）",
  "Frame Rate": "帧率",
  Resolution: "分辨率",
  "Keep Resolution": "保持原分辨率",
  Format: "格式",
  Compress: "压缩",
  Compressing: "压缩中",
  "Compress New": "压缩新的（文件）",
  "xx% reduction in size!": "减少了{{num}}%体积大小",
  "Compressed successfully, your file is now xxMB.": "压缩成功，你的文件现在<p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>",
  "Compression Failed": "压缩失败",
};
